import React from "react";
import {
    Button,
    Dialog as MDialog,
    DialogActions as MDialogActions,
    DialogContent as MDialogContent,
} from "@material-ui/core";

import { useTranslation } from "react-i18next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/pro-light-svg-icons";

import type { DialogCloseReason, DialogProps } from "./Dialog";
import { DialogTitle } from "./DialogTitle";

type OkCancelDialogProps = DialogProps & {
    okButtonText: string;
    onClose: (reason: DialogCloseReason) => void;
};

export const OkCancelDialog = (props: OkCancelDialogProps) => {
    const { t } = useTranslation();
    const { dialogOptions, okButtonText, onClose, open, subTitle, subTitle2, title, children } = props;

    const handleOk = () => {
        onClose("okButtonClick");
    };

    const handleCancel = (reason: DialogCloseReason) => {
        onClose(reason);
    };

    return (
        <MDialog
            open={open}
            maxWidth="xs"
            disableBackdropClick
            disablePortal
            onClose={(_, reason) => handleCancel(reason)}
            {...dialogOptions}
        >
            <DialogTitle title={title} subTitle={subTitle} subTitle2={subTitle2} />
            <MDialogContent dividers>{children}</MDialogContent>
            <MDialogActions>
                <Button autoFocus variant="contained" color="default" onClick={() => handleCancel("cancelButtonClick")}>
                    {t("Gui.Buttons.Cancel")}
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    startIcon={<FontAwesomeIcon fixedWidth icon={faCheck} />}
                    onClick={() => handleOk()}
                >
                    {t(okButtonText ?? "Gui.Buttons.Ok")}
                </Button>
            </MDialogActions>
        </MDialog>
    );
};
